import React, { Component } from 'react'

class Card extends Component {
  constructor(props) {
    super(props)
    this.state = { isCollapsed: false }

    this.card = null
    this.setCardRef = (el) => {
      this.card = el
    }
    this.cardTypeClass = {
      primary: 'bg-primary',
      dark: 'bg-darkest',
    }
    this.cardClass = `card membership-card text-white ${
      this.cardTypeClass[props.type]
    }`
  }

  componentDidUpdate(prevProps) {
    const { isCollapsible } = this.props
    const inSignUp =
      prevProps.isCollapsible != isCollapsible && !prevProps.isCollapsible
    const outSignUp =
      prevProps.isCollapsible != isCollapsible && prevProps.isCollapsible

    if (inSignUp && !this.state.isCollapsed) this.collapseCard()
    if (outSignUp && this.state.isCollapsed) this.uncollapseCard(false)
  }

  onAngleDownClick() {
    this.state.isCollapsed ? this.uncollapseCard() : this.collapseCard()
  }

  collapseCard() {
    this.setState({ isCollapsed: true })
    this.card.className = `${this.cardClass} membership-card-collapsed`
  }

  uncollapseCard(withinMidHeight = true) {
    this.setState({ isCollapsed: false })
    this.card.className = `${this.cardClass} ${
      withinMidHeight && 'membership-card-mid-height'
    }`
  }

  render() {
    const {
      type,
      title,
      text,
      list,
      price,
      pricePeriod,
      btnText,
      btnUrl,
      onActionBtnClick,
      attentionText,
      i18n,
      isSignUp,
      isCollapsible,
    } = this.props

    const ornamentClass = {
      primary: `membership-card-ornament--dark`,
      dark: `membership-card-ornament--primary`,
    }

    return (
      <div ref={this.setCardRef} className={this.cardClass}>
        <div className={ornamentClass[type]} />
        <div
          className={`card-body membership-card-body d-flex flex-column ${
            !isCollapsible && 'justify-content-between'
          }`}
        >
          {/* Collapse Button Start */}
          {isCollapsible && (
            <i
              className="fa fa-angle-down"
              onClick={() => this.onAngleDownClick()}
            ></i>
          )}
          {/* Collapse Button End */}

          {/* Title Start */}
          <h4 className="card-title text-warning text-uppercase font-weight-bold mt-2">
            {title}
          </h4>
          {/* Title End */}

          {/* Subtitle Start */}
          <p className="card-text membership-card-text">{text}</p>
          {/* Subtitle End */}

          {/* Benefits List Start */}
          <ul className="membership-card-list">
            {list.map((item, i) => {
              return (
                <li key={i} className="my-2">
                  <div className="d-flex">
                    <div className="bullet mr-2" />
                    <span>{item}</span>
                  </div>
                </li>
              )
            })}
          </ul>
          {/* Benefits List End */}

          {/* Price Start */}
          <div className="d-flex flex-column membership-card-price">
            <div>
              <span>{i18n.t('membership.from')}</span>
            </div>
            <div className="d-flex align-items-baseline">
              <h3 className="text-warning font-weight-bold mb-0">{price}</h3>
              <small className="ml-1 price-period">{pricePeriod}</small>
            </div>
          </div>
          {/* Price End */}

          {/* Attention text Start */}
          {attentionText && (
            <div className="mt-3">
              <p className="attention-text font-italic">
                <span>
                  <b>{i18n.t('membership.renewal.attentionTitle')}</b>
                  {attentionText}
                </span>
              </p>
            </div>
          )}
          {/* Attention text End */}

          {/* Action Button Start */}
          {!isCollapsible && (
            <div className="text-center">
              {isSignUp ? (
                <button
                  type="button"
                  className="btn btn-outline-white"
                  onClick={() => onActionBtnClick()}
                >
                  {btnText}
                </button>
              ) : (
                <a
                  href={btnUrl}
                  target="_blank"
                  className="btn btn-outline-white"
                >
                  {btnText}
                </a>
              )}
            </div>
          )}
          {/* Action Button End */}
        </div>
      </div>
    )
  }
}

export default Card
